import './Tooltip.scss';
import { Component } from '@components/Component/Component.js';
import { createElement, plaintextToHTML, sanitizeHTML } from '@components/Utility/index.js';
/**
 * `Tooltip` component.
 */
export class Tooltip extends Component {
    get value() { return this._value; }
    set value(value) {
        this._propertySet('value', value);
        this.renderValue();
    }
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Tooltip';
        this._value = '';
    }
    draw() {
        super.draw();
        this.renderValue();
    }
    renderValue() {
        if (this.drawn) {
            const value = sanitizeHTML(plaintextToHTML(this.value, ''));
            this.rootElement.innerHTML = value;
        }
    }
    appendLoadingThrobber() {
        if (this.rootElement && this.loadingThrobber) {
            const throbberRoot = createElement('div');
            throbberRoot.style.height = '40px';
            throbberRoot.style.width = '40px';
            this.rootElement.appendChild(throbberRoot);
            throbberRoot.style.position = 'relative'; // throbber position is absolute so its parent must be relative to position it correctly to cover the component that is loading.
            throbberRoot.appendChild(this.loadingThrobber.rootElement);
        }
    }
}
Tooltip.VERSION = '$Revision: 112048 $';
